import React from 'react';
import { StarIcon, MoreVerticalIcon } from 'lucide-react';
import { mockApps } from '../../utils/mockData';
import { getIcon } from '../../utils/iconUtils';
import { useNavigate } from 'react-router-dom';
interface AppListViewProps {
  onOpenApp: (appId: string) => void;
  createAppTile?: any;
}
export const AppListView = ({
  onOpenApp,
  createAppTile
}: AppListViewProps) => {
  const navigate = useNavigate();
  // Mobile card view
  const MobileListView = () => <div className="md:hidden space-y-4" data-id="element-240">
      {mockApps.map(app => <div key={app.id} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-241">
          <div className="flex items-center space-x-3" data-id="element-242">
            <div className={`${app.iconBg} w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-243">
              {getIcon(app.icon)}
            </div>
            <div className="flex-1 min-w-0" data-id="element-244">
              <h3 className="font-medium text-gray-900 truncate" data-id="element-245">
                {app.title}
              </h3>
              <p className="text-sm text-gray-500 truncate" data-id="element-246">{app.author}</p>
            </div>
            <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-247">
              <MoreVerticalIcon className="h-5 w-5" data-id="element-248" />
            </button>
          </div>
          <div className="mt-3 flex items-center justify-between" data-id="element-249">
            <div className="flex items-center" data-id="element-250">
              <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-251" />
              <span className="ml-1 text-sm font-medium" data-id="element-252">{app.rating}</span>
            </div>
            <div className="text-sm text-gray-500" data-id="element-253">{app.category}</div>
            <div className="text-sm text-gray-500" data-id="element-254">{app.updated}</div>
          </div>
        </div>)}
    </div>;
  // Desktop table view
  const DesktopListView = () => <div className="hidden md:block overflow-hidden bg-white rounded-lg border border-gray-200" data-id="element-255">
      <div className="overflow-x-auto" data-id="element-256">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-257">
          <thead className="bg-gray-50" data-id="element-258">
            <tr data-id="element-259">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-260">
                App
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-261">
                Category
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-262">
                Rating
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-263">
                Last Used
              </th>
              <th scope="col" className="relative px-6 py-3" data-id="element-264">
                <span className="sr-only" data-id="element-265">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-266">
            {mockApps.map(app => <tr key={app.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-267">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-268">
                  <div className="flex items-center" data-id="element-269">
                    <div className={`${app.iconBg} w-8 h-8 rounded-lg flex items-center justify-center`} data-id="element-270">
                      {getIcon(app.icon)}
                    </div>
                    <div className="ml-4" data-id="element-271">
                      <div className="text-sm font-medium text-gray-900" data-id="element-272">
                        {app.title}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-273">{app.author}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-274">
                  <span className="text-sm text-gray-900" data-id="element-275">{app.category}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-276">
                  <div className="flex items-center" data-id="element-277">
                    <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-278" />
                    <span className="ml-1 text-sm text-gray-900" data-id="element-279">
                      {app.rating}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-280">
                  {app.updated}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-281">
                  <button className="text-gray-400 hover:text-gray-600 p-2" onClick={e => {
                e.stopPropagation();
                // Handle menu click
              }} data-id="element-282">
                    <MoreVerticalIcon className="h-5 w-5" data-id="element-283" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  return <>
      <MobileListView data-id="element-284" />
      <DesktopListView data-id="element-285" />
    </>;
};